import ApiCLient from '@/api/client';
import { ErrorService } from '@/services/error-service.js';

const GEOSERV_REST_API_PATH = '/geoserv/rest/workspaces';
const GEOSERV_MIRROR_API_PATH = '/geoserv/mirror/';

class GeoserverAPI extends ApiCLient {

  constructor() {
    super();
  }

  /** GET */
  async getWorkspaces() {
    try {
      const response = await this.get(`${GEOSERV_REST_API_PATH}.json`);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch(err) {
      console.error(err);
      return false;
    }
  }
  async getWorkspaceLayers(workspace) {
    try {
      const response = await this.get(`${GEOSERV_REST_API_PATH}/${workspace}/layers.json`);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch(err) {
      console.error(err);
    }
  }
  async getWorkspaceLayergroups(workspace) {
    try {
      const response = await this.get(`${GEOSERV_REST_API_PATH}/${workspace}/layergroups.json`);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch(err) {
      console.error(err);
    }
  }

  /** CREATE */
  async createGeoserverSource(data) {
    try {
      let name;
      if (data['layer'] !== null) {
        name = `${data.workspace.name}:${data['layer'].name}`;
      }
      else if (data['layergroup'] !== null) {
        name = `${data.workspace.name}:${data['layergroup'].name}`;
      }

      const response = await this.post(`${GEOSERV_MIRROR_API_PATH}${data.layerType}/`, { name: name });
      if ([201, 200].includes(response.status)) {
        return response.data;
      }
      return false;
    } catch(err) {
      ErrorService.onError(err);
      return false;
    }
  }

  /** UPDATE */
  async updateGeoservResource(id, type, data, async = true) {
    const route = `${GEOSERV_MIRROR_API_PATH}${type}/${id}/?asynchrone=${async}`;
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** SCENARII */
  async getGeoserverResourceScenarios(type, id) {
    const response = await this.get(`${GEOSERV_MIRROR_API_PATH}${type}/${id}/_scenarios/`);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runGeoserverResourceScenario(type, id, scenarioId, data) {
    const route = `${GEOSERV_MIRROR_API_PATH}${type}/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`;
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }
};

const geoserverAPI = new GeoserverAPI();
export default geoserverAPI;